import React from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router';
import Button from '../ui/form/Button';
import Page, { PageTitle } from '../ui/Page';
import List from '../render_queue/List';
import Create from '../render_queue/Create';
import RenderQueue from '../render_queue/RenderQueue';

export default function RenderQueues() {
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  return (
    <Page title={'Render Queues'}>
      <PageTitle>
        {location.pathname === '/render-queues' && (
          <Button
            label="New Render Queue +"
            onClick={() => {
              history.push('/render-queues/create');
            }}
          />
        )}
      </PageTitle>
      <Switch>
        <Route path={`${match.path}/create`}>
          <Create />
        </Route>
        <Route path={`${match.path}/:queueid`}>
          <RenderQueue />
        </Route>
        <Route path={match.path}>
          <List />
        </Route>
      </Switch>
    </Page>
  );
}
